import React, { Component } from "react";
import { Grid, Accordion, Icon, List } from "semantic-ui-react";


class Info extends Component {
  state = {
    activeindex: null
  };
  componentDidUpdate(prevProps, prevState) {
    console.log(this.state.activeindex);
  }
  render() {
    let geninfopath = 'http://23.31.37.220:8080/static/geninfo/'
    let downloadspath = 'http://23.31.37.220:8080/downloads/'
    return (
      <div className="Info">
        <Grid>
          <Grid.Column width={10}>
            <Accordion styled fluid>
              {/* 3D Modeling */}
              <Accordion.Title
                active={this.state.activeindex === 0}
                onClick={() => this.setState({ activeindex: 0 })}
                fluid
                as="h3"
              >
                <Icon name="codepen" /> 3D Modeling
              </Accordion.Title>
              <Accordion.Content active={this.state.activeindex === 0}>
                <List relaxed divided>
                  <List.Item>
                    <List.Content>
                      <List.Header>
                        3D Rotate
                      </List.Header>
                      <List.Description>
                        Moving objects about a three-dimensional axis.
                        <br />
                        <Icon link name='eye' onClick={() => window.open(geninfopath + '3dmodel/3dRotate.pdf')} />
                      </List.Description>
                    </List.Content>
                  </List.Item>
                  <List.Item>
                    <List.Content>
                      <List.Header>
                        Coordinate Point Filters
                      </List.Header>
                      <List.Description>
                        An explanation of two-dimensional and three-dimensional
                        Cartesian coordinate planes as used with coordinate
                        point filters in AutoCAD.
                        <br />
                        <Icon link name='eye' onClick={() => window.open(geninfopath + '3dmodel/coordinatePointFilters.pdf')} />
                      </List.Description>
                    </List.Content>
                  </List.Item>
                </List>
              </Accordion.Content>
              {/* Dimensioning */}
              <Accordion.Title
                fluid
                as="h3"
                active={this.state.activeindex === 1}
                onClick={() => this.setState({ activeindex: 1 })}
              >
                <Icon name="resize vertical" /> Dimensioning
              </Accordion.Title>
              <Accordion.Content active={this.state.activeindex === 1}>
                <List divided>
                  <List.Item>
                    <List.Content>
                      <List.Header>
                        ASME Y14.5 EDF Dimensioning Training
                      </List.Header>
                      <List.Description>
                        This document is to provide mechanical design and
                        drafting guidelines with reference to ASME Y14.5. See
                        ASME Y14.5 Dimensioning and Tolerancing for the complete
                        standard.
                        <br />
                        <Icon link name='eye' onClick={() => window.open(geninfopath + 'dimensioning/ASMEY145EDFDimensioningTraining.pdf')} />
                      </List.Description>
                    </List.Content>
                  </List.Item>
                  <List.Item>
                    <List.Content>
                      <List.Header>
                        Geometric Tolerancing
                      </List.Header>
                      <List.Description>
                        The official ASME document regarding dimensioning and
                        tolerancing in a geometric environment.
                        <br />
                        <Icon link name='eye' onClick={() => window.open(geninfopath + 'dimensioning/geometricTolerancing.pdf')} />
                      </List.Description>
                    </List.Content>
                  </List.Item>
                </List>
              </Accordion.Content>
              {/* Documentum/Doc Access */}
              <Accordion.Title
                fluid
                as="h3"
                active={this.state.activeindex === 2}
                onClick={() => this.setState({ activeindex: 2 })}
              >
                <Icon name="database" /> Documentum/Doc Access
              </Accordion.Title>
              <Accordion.Content active={this.state.activeindex === 2}>
                <List divided>
                  <List.Item>
                    <List.Content>
                      <List.Header>
                        Access TSE Drawings Via Documentum (All)
                      </List.Header>
                      <List.Description>
                        View drawings stored in Documentum for printing or
                        reference.
                        <br />
                        <Icon link name='eye' onClick={() => window.open(geninfopath + 'documentum/accessTSEDrawingsViaDocumentum.pdf')} />
                      </List.Description>
                    </List.Content>
                  </List.Item>
                  <List.Item>
                    <List.Content>
                      <List.Header>
                        Document Access (DocAccess)
                      </List.Header>
                      <List.Description>
                        Using DocAccess, a web-based drawing management
                        solution.
                        <br />
                        <Icon link name='eye' />
                      </List.Description>
                    </List.Content>
                  </List.Item>
                </List>
              </Accordion.Content>
              {/* Drawing Setup */}
              <Accordion.Title
                active={this.state.activeindex === 4}
                fluid
                as="h3"
                onClick={() => this.setState({ activeindex: 4 })}
              >
                <Icon name="object group" /> Drawing Setup
              </Accordion.Title>
              <Accordion.Content active={this.state.activeindex === 4}>
                <List divided>
                  <List.Item>
                    <List.Content>
                      <List.Header>
                        Border Scaler
                      </List.Header>
                      <List.Description>
                        This document is to provide mechanical design and
                        drafting guidelines with reference to ASME Y14.5. See
                        ASME Y14.5 Dimensioning and Tolerancing for the complete
                        standard.
                        <br />
                      <Icon link name='download' onClick={() => window.open(downloadspath + 'borderScaler.xls')} />
                      </List.Description>
                    </List.Content>
                  </List.Item>
                  <List.Item>
                    <List.Content>
                      <List.Header>
                        Setting up a UG Drawing & DDM
                      </List.Header>
                      <List.Description>
                        This is a basic start up process in creating a UG
                        drawing. It will show you the help menu which can teach
                        most aspects of the CAD tools. Then it shows where to
                        find all of the basic P&W drafting setup menus. There is
                        also a link to the DDM users manual.
                        <br />
                        <Icon link name='eye' onClick={() => window.open(geninfopath + 'dwgSetup/UGhowto.pdf')} />
                      </List.Description>
                    </List.Content>
                  </List.Item>
                </List>
              </Accordion.Content>
              {/* Policies and Procedures */}
              <Accordion.Title
                fluid
                as="h3"
                active={this.state.activeindex === 5}
                onClick={() => this.setState({ activeindex: 5 })}
              >
                <Icon name="book" /> Policies and Procedures
              </Accordion.Title>
              <Accordion.Content active={this.state.activeindex === 5}>
                <List divided>
                  <List.Item>
                    <List.Content>
                      <List.Header>
                        Employee Handbook
                      </List.Header>
                      <List.Description>
                        The Employee Handbook provides a wealth of information
                        regarding what is expected of employees and what is
                        expected of EDF. Valuable information regarding
                        benefits, workers compensation, and other key issues can
                        also be found.
                        <br />
                        <Icon link name='eye' onClick={() => window.open(geninfopath + 'policies/basic_employment_policies.pdf')} />
                      </List.Description>
                    </List.Content>
                  </List.Item>
                  <List.Item>
                    <List.Content>
                      <List.Header>
                        EDF Handbook Addendum
                      </List.Header>
                      <List.Description>
                        EDF policies in addition to the Handbook.
                        <br />
                        <Icon link name='eye' onClick={() => window.open(geninfopath + 'policies/edfPolicies.pdf')} />
                      </List.Description>
                    </List.Content>
                  </List.Item>
                  <List.Item>
                    <List.Content>
                      <List.Header>
                        Blank Expense Report
                      </List.Header>
                      <List.Description>
                        Blank expense report for recording business related
                        expenses.
                        <br />
                        <Icon link name='download' onClick={() => window.open(downloadspath + 'blank_expense_report.xls')} />
                      </List.Description>
                    </List.Content>
                  </List.Item>
                  <List.Item>
                    <List.Content>
                      <List.Header>
                        Employee Injury Report Form
                      </List.Header>
                      <List.Description>
                        Work related injury report form.
                        <br />
                        <Icon link name='eye' onClick={() => window.open(geninfopath + 'policies/injury_blank.pdf')} />
                      </List.Description>
                    </List.Content>
                  </List.Item>
                  <List.Item>
                    <List.Content>
                      <List.Header>
                        Office Ergonomics in the Workplace
                      </List.Header>
                      <List.Description>
                        Outlines proper workplace ergonomics.
                        <br />
                        <Icon link name='eye' onClick={() => window.open(geninfopath + 'policies/officeErgonomics.pdf')} />
                      </List.Description>
                    </List.Content>
                  </List.Item>
                  <List.Item>
                    <List.Content>
                      <List.Header>
                        Office Ergonomics Quiz
                      </List.Header>
                      <List.Description>
                        Quiz on proper workplace ergonomics.
                        <br />
                        <Icon link name='eye' onClick={() => window.open(geninfopath + 'policies/officeErgonomicsQuiz.pdf')} />
                      </List.Description>
                    </List.Content>
                  </List.Item>
                  <List.Item>
                    <List.Content>
                      <List.Header>
                        Safety Policies Consent Form
                      </List.Header>
                      <List.Description>
                        Consent form for safety policies.
                        <br />
                        <Icon link name='eye' onClick={() => window.open(geninfopath + 'policies/safety_policies_consent_form.pdf')} />
                      </List.Description>
                    </List.Content>
                  </List.Item>
                  <List.Item>
                    <List.Content>
                      <List.Header>
                        Sexual Harrasment Prevention in the Workplace
                      </List.Header>
                      <List.Description>
                        Sexual harrasment policy and guidelines in the workplace.
                        <br />
                        <Icon link name='eye' onClick={() => window.open(geninfopath + 'policies/sexualHarassment.pdf')} />
                      </List.Description>
                    </List.Content>
                  </List.Item>
                  <List.Item>
                    <List.Content>
                      <List.Header>
                        Sexual Harrasment Prevention in the Workplace Quiz
                      </List.Header>
                      <List.Description>
                        Quiz on sexual harrasment policy and guidelines in the workplace
                        <br />
                        <Icon link name='eye' onClick={() => window.open(geninfopath + 'policies/sexualHarassmentQuiz.pdf')} />
                      </List.Description>
                    </List.Content>
                  </List.Item>
                  <List.Item>
                    <List.Content>
                      <List.Header>
                        Traffic and Parking (Florida and P&W Facility Only)
                      </List.Header>
                      <List.Description>
                        Traffic rules and parking guidelines for the Florida and P&W facility.
                        <br />
                        <Icon link name='eye' onClick={() => window.open(geninfopath + 'policies/trafficParking.pdf')} />
                      </List.Description>
                    </List.Content>
                  </List.Item>
                </List>
              </Accordion.Content>
              {/* Standards */}
              <Accordion.Title
                fluid
                as="h3"
                active={this.state.activeindex === 6}
                onClick={() => this.setState({ activeindex: 6 })}
              >
                <Icon name="legal" /> Standards
              </Accordion.Title>
              <Accordion.Content active={this.state.activeindex === 6}>
                <List divided>
                  <List.Item>
                    <List.Content>
                      <List.Header>
                        EDF Letterhead
                      </List.Header>
                      <List.Description>
                        EDF Standard letterhead
                        <br />
                        <Icon link name='download' onClick={() => window.open(downloadspath + 'edfLetterhead.docx')} />
                      </List.Description>
                    </List.Content>
                  </List.Item>
                  <List.Item>
                    <List.Content>
                      <List.Header>
                        IHS Specs for Hardware
                      </List.Header>
                      <List.Description>
                        Standard hardware specifications and requirements per
                        IHS, Inc.
                        <br />
                      </List.Description>
                    </List.Content>
                  </List.Item>
                </List>
              </Accordion.Content>
            </Accordion>
          </Grid.Column>
        </Grid>
      </div>
    );
  }
}
export default Info;



// WEBPACK FOOTER //
// ./src/components/info/info.js